import type { Envelope } from '../../types';
import { saveToStorage } from '../storage-api-utils';
import { updateRecordInRegistry } from '../feature-metadata';

export const writeEnvelope = (
    envelopeKey: string,
    metadataKey: string,
    data: unknown,
    savedAt: number = Date.now(),
    storage: Storage
) => {
    const envelope: Envelope = {
        data,
        savedAt,
    };

    saveToStorage(envelopeKey, envelope, storage);
    updateRecordInRegistry(metadataKey, envelopeKey, savedAt, storage);
};
